import firebase from 'firebase/compat/app'
import { getAnalytics } from 'firebase/analytics'
import 'firebase/firestore'

let configOptions = {
  apiKey: "AIzaSyD6G6j9wB5OXyrblwU9Sv52TaenZwrODVw",
  authDomain: "texas-ave-social.firebaseapp.com",
  projectId: "texas-ave-social",
  storageBucket: "texas-ave-social.appspot.com",
  messagingSenderId: "510059031073",
  appId: "1:510059031073:web:378541020749291a705160",
  measurementId: "G-K1R3WN91SB"
};

if (process.env.NODE_ENV === 'development') {
    configOptions = {
      apiKey: "AIzaSyD6G6j9wB5OXyrblwU9Sv52TaenZwrODVw",
      authDomain: "texas-ave-social.firebaseapp.com",
      projectId: "texas-ave-social",
      storageBucket: "texas-ave-social.appspot.com",
      messagingSenderId: "510059031073",
      appId: "1:510059031073:web:378541020749291a705160",
      measurementId: "G-K1R3WN91SB"
    };
}


//// eslint-disable-next-line import/no-mutable-exports
let db
function initFirebase() {
  const app = firebase.initializeApp(configOptions)
  getAnalytics(app)
  
  db = firebase.firestore()
  
  return new Promise((resolve, reject) => {
    firebase.firestore().enablePersistence()
      .then(resolve)
      .catch((err) => {
        if (err.code === 'failed-precondition') {
          reject(err)
          // Multiple tabs open, persistence can only be
          // enabled in one tab at a a time.
        } else if (err.code === 'unimplemented') {
          reject(err)
          // The current browser does not support all of
          // the features required to enable persistence
        }
      })
  })
}

// const

export {
  db,
  firebase,
  initFirebase,
}
